import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { PainSection } from '../components/PainSection';
import { TruthSection } from '../components/TruthSection';
import { ProductPresentation } from '../components/ProductPresentation';
import { ContentBreakdown } from '../components/ContentBreakdown';
import { BenefitsSection } from '../components/BenefitsSection';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { ForYouSection } from '../components/ForYouSection';
import { GuaranteeSection } from '../components/GuaranteeSection';
import { ValueStack } from '../components/ValueStack';
import { FAQSection } from '../components/FAQSection';
import { ImpactPhrases } from '../components/ImpactPhrases';
import { Footer } from '../components/Footer';
export function SalesPage() {
  return <div className="min-h-screen bg-[#FFF8F0] font-sans selection:bg-[#FFCC80] selection:text-gray-900" data-id="element-401">
      <HeroSection data-id="element-402" />
      <PainSection data-id="element-403" />
      <TruthSection data-id="element-404" />
      <ProductPresentation data-id="element-405" />
      <ContentBreakdown data-id="element-406" />
      <BenefitsSection data-id="element-407" />
      <TestimonialsSection data-id="element-408" />
      <ForYouSection data-id="element-409" />
      <GuaranteeSection data-id="element-410" />
      <ValueStack data-id="element-411" />
      <FAQSection data-id="element-412" />
      <ImpactPhrases data-id="element-413" />
      <Footer data-id="element-414" />
    </div>;
}